import { useEffect, useRef } from 'react'

import type { InvoicingSettingsSection } from '../../../../../enums/invoicingSettingsSection'

// Assign `scrollTop` rather than calling `scrollTo`: JSDOM does not implement `Element.scrollTo`.
export const useResetInvoicingSettingsFormScroll = (activeSection: InvoicingSettingsSection) => {
  const formWrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (formWrapperRef.current) {
      formWrapperRef.current.scrollTop = 0
    }
  }, [activeSection])

  return formWrapperRef
}
